module.exports = __webpack_public_path__ + "static/media/Vite.js.821704fd.svg";